module.exports = __webpack_public_path__ + "img/tesys.ced9f7a6.png";